import React, { useEffect, useState } from "react";
import "./cursor.css";

const Cursor = () => {
  const [hovered, setHovered] = useState(false);

  useEffect(() => {
    const cursor = document.querySelector(".custom-cursor");

    const moveCursor = (e) => {
      cursor.style.top = `${e.clientY}px`;
      cursor.style.left = `${e.clientX}px`;
    };

    const addHover = () => setHovered(true);
    const removeHover = () => setHovered(false);

    // Track mouse movement
    window.addEventListener("mousemove", moveCursor);

    // Track hover on all buttons and links
    const buttons = document.querySelectorAll("button, a");
    buttons.forEach((btn) => {
      btn.addEventListener("mouseenter", addHover);
      btn.addEventListener("mouseleave", removeHover);
    });

    return () => {
      window.removeEventListener("mousemove", moveCursor);
      buttons.forEach((btn) => {
        btn.removeEventListener("mouseenter", addHover);
        btn.removeEventListener("mouseleave", removeHover);
      });
    };
  }, []);

  return (
    <div className={`custom-cursor ${hovered ? "hovered" : ""}`}></div>
  );
};

export default Cursor;
